import { AspectRatio } from '../types/Camera/AspectRatio';

export const getAspectRatio = (payload: AspectRatio) => {
  if (payload.style === 'card') {
    if (payload.orientation.includes('portrait')) {
      // 2.125 x 3.370
      return 0.6306;
    }
    // 3.370 x 2.125
    return 1.586;
  }

  if (payload.style === 'document') {
    return 1.294;
  }

  if (payload.style === 'portrait') {
    return 0.85;
  }
};
